import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGameInfo } from "../interfaces/game-info";
import { IMakerCheckerGamesState } from "../interfaces/slices";

const initialState: IMakerCheckerGamesState = {
    info: {}
}

export const makerCheckerGamesSlice = createSlice({
    name: 'makerCheckerGames',
    initialState,
    reducers: {
        addSentForApprovalGames: (state, action: PayloadAction<Array<IGameInfo>>) => {
            state.info = {};
            action.payload.forEach((info: IGameInfo) => {
                state.info[info.gameName] = info;
            })
        },
    },
})

export const { addSentForApprovalGames } = makerCheckerGamesSlice.actions
export default makerCheckerGamesSlice.reducer;